import * as React from "react";

export const ContinentTag = ({
    locationName,
    className
}: {
    locationName: string;
    className?: string;
}) => {
    return (
        <p
            className={`inline rounded-xl bg-white px-3 py-1 text-xs font-bold ${className}`}
        >
            {locationName}
        </p>
    );
};
